// extracted by mini-css-extract-plugin
export default {"label":"Gravatar_label__-TbIF","avatar":"Gravatar_avatar__Cn2EU"};